export default {
    "lang": "韩语",
    "application": {
        "name": "정보 발송 시스템"
    },
    "ajaxTip": {
        "success": "성공",
        "error": "실패",
        "noAccess": "이 자원에 접근할 권한이 없습니다",
        "notFound": "접근한 자원이 존재하지 않습니다",
        "serverBusy": "서버가 바쁩니다",
        "timeOut": "시간 초과"
    },
    "menu": {
        "home": "홈페이지",
        "template": "템플릿 관리",
        "program": "프로그램 관리",
        "playplan": "재생 계획",
        "device": "장치 관리",
        "source-material": "소재 관리",
        "material": "소재",
        "checkManage": "심사 관리",
        "setting": "설정",
        "usercenter": "사용자 센터",
        "adminManage": "장치 관리",
        "schedule": "대기 업무",
        "capitalassets": "자산 관리",
        "modifyPassword": "비밀번호 수정",
        "logout": "로그아웃",
        "add": "추가",
        "edit": "편집",
        "delete": "삭제",
        "view": "보기",
        "menu_1": "홈페이지",
        "menu_2": "장비 관리",
        "menu_3": "편집(고급 설정-기본 편집-네트워크 변경)",
        "menu_4": "즉시 명령",
        "menu_5": "편집(부서 이동)",
        "menu_6": "전략",
        "menu_7": "볼륨 설정",
        "menu_8": "밝기 설정",
        "menu_9": "다운로드 설정",
        "menu_10": "대기 모드 설정",
        "menu_11": "장비 속성",
        "menu_12": "편집/추가",
        "menu_13": "프로그램 관리",
        "menu_14": "게시 내역",
        "menu_15": "삭제 (일괄/개별)",
        "menu_16": "게시 중인 프로그램",
        "menu_17": "그룹화",
        "menu_19": "프로그램 목록",
        "menu_20": "콘텐츠 편집",
        "menu_21": "프로그램 복사",
        "menu_23": "프로그램 게시",
        "menu_24": "자료 관리",
        "menu_25": "업로드",
        "menu_28": "빠른 게시",
        "menu_29": "템플릿 관리",
        "menu_30": "공용 템플릿",
        "menu_31": "즉시 사용",
        "menu_32": "내 템플릿",
        "menu_33": "공용 템플릿에 게시",
        "menu_35": "공유 기록",
        "menu_36": "검토 관리",
        "menu_37": "프로그램 검토",
        "menu_38": "검토 (승인/거절)",
        "menu_39": "자료 검토",
        "menu_41": "검토 내역 (운영자)",
        "menu_42": "검토 내역 (검토자)",
        "menu_43": "승인 수량 조회",
        "menu_44": "조직 관리",
        "menu_45": "로그 관리",
        "menu_46": "재생 로그",
        "menu_47": "게시 로그",
        "menu_48": "오류 로그",
        "menu_49": "작업 로그",
        "menu_50": "파일 로그",
        "menu_51": "로그인 로그",
        "menu_52": "콘텐츠 승인",
        "menu_53": "저장 공간",
        "menu_54": "조직 구조",
        "menu_55": "역할 권한",
        "menu_56": "권한 부여",
        "menu_57": "조회(권한 부여 권한)",
        "menu_58": "조직 구성원",
        "menu_60": "하위 사용자 비밀번호 재설정",
        "menu_61": "자산 관리",
        "menu_62": "내 잔액",
        "menu_63": "조회(자금 상세)",
        "menu_64": "내 데이터 사용량",
        "menu_65": "조회(데이터 사용량 상세)",
        "menu_66": "데이터 사용량 구매",
        "menu_67": "내 용량",
        "menu_68": "내 장비",
        "menu_69": "주문 상세",
        "menu_70": "조회(충전)",
        "menu_71": "조회(구매한 템플릿)",
        "menu_72": "조회(구매한 데이터 사용량)",
        "menu_73": "기타 권한",
        "menu_74": "조회(자료 및 프로그램 통계)",
        "menu_75": "조회(자산)",
        "menu_76": "조회(클라우드 데이터 사용량/통계)",
        "menu_77": "조회(장비 온라인 통계)"
    },
    "login": {
        "terminalServiceSystem": "스마트 단말 서비스 시스템",
        "accountLogin": "계정 로그인",
        "register": "등록",
        "accountLoginTip": "기존 계정으로 로그인",
        "scanQRCode": "QR 코드를 스캔해 주세요",
        "readAndAgree": "저는 읽고 동의합니다",
        "readAndAgreeLink": "사용자 서비스 약관",
        "readAndAgreeAgreement": "사용자 서비스 약관을 읽고 동의해 주세요",
        "forgetpassword": "비밀번호를 잊으셨나요?",
        "resetpassword": "비밀번호 재설정",
        "phoneEmptyTip": "휴대폰 번호를 입력해 주세요",
        "nextStep": "다음 단계",
        "title": "환영합니다, 로그인해 주세요",
        "submit": "로그인",
        "userName": "계정",
        "password": "비밀번호",
        "userNameEmptyTip": "계정을 입력해 주세요",
        "passwordEmptyTip": "비밀번호를 입력해 주세요",
        "passwordFormatTip": "올바른 비밀번호 형식을 입력해 주세요",
        "passwordIsOk": "비밀번호 확인을 입력해 주세요",
        "passwordSign": "비밀번호를 입력해 주세요",
        "codeTip": "인증 코드를 입력해 주세요",
        "phone": "휴대폰 번호는 필수입니다",
        "code": "인증 코드는 필수입니다",
        "nickname": "회사 이름은 필수입니다",
        "pass": "비밀번호는 필수입니다",
        "pwdMessage": "비밀번호는 8~20자 이내이며, 공백을 포함할 수 없고 대소문자, 숫자, 특수 문자 중 임의 3종을 포함해야 합니다",
        "pwdMessage01": "알파벳과 숫자를 조합한 8자 이상의 비밀번호를 입력해 주세요",
        "pwdMessage02": "비밀번호는 8-20자 이내여야 합니다",
        "pwdMessage03": "비밀번호에 공백을 포함할 수 없습니다",
        "pwdMessage04": "비밀번호는 대문자, 소문자, 숫자, 기호 중 세 종류를 포함해야 합니다",
        "newpassempty": "새 비밀번호는 필수입니다",
        "newpass": "두 번 입력한 비밀번호가 일치하지 않습니다",
        "getcode": "인증 코드 받기",
        "format": "휴대폰 번호 형식이 올바르지 않습니다",
        "chongfa": "초 후 재전송",
        "isSend": "전송 완료",
        "noregister": "계정이 없으신가요? 즉시 등록",
        "Mobile": "휴대폰 번호",
        "verificationcode": "인증 코드",
        "petname": "닉네임",
        "Quickregistration": "빠른 등록",
        "xiugaimima": "비밀번호 수정",
        "jiumima": "기존 비밀번호",
        "xinmima": "새 비밀번호",
        "zaicishuruxinmima": "새 비밀번호 다시 입력",
        "xiugaichenggong": "수정 성공",
        "xiugaishoujihao": "휴대폰 번호 수정",
        "dengluzhanghao": "로그인 계정",
        "gongsiid": "회사 ID",
        "yonghunicheng": "사용자 닉네임",
        "chuangjianshijian": "생성 시간",
        "gongsimingcheng": "회사 이름",
        "denglumima": "로그인 비밀번호",
        "jianyi": "알파벳과 숫자를 조합한 비밀번호 사용을 권장합니다",
        "shezhimima": "비밀번호 설정",
        "shezhishoujihao": "휴대폰 번호 수정/설정",
        "yibangding": "연결 완료",
        "weibangding": "연결되지 않음",
        "zhanghuanquan": "계정 보안",
        "yonghuxinxi": "사용자 정보",
        "zhuceSucMsg": "축하합니다, 등록 성공!",
        "verificationcodeSucMsg": "인증 코드 전송 성공！",
        "requiredIsEmpty": "필수 항목은 비어 있을 수 없습니다！",
        "emailObj": {
            "title": "이메일",
            "tit": "이메일 로그인",
            "tip": "이메일 주소를 입력해 주세요",
            "formatTip": "올바른 이메일 형식을 입력해 주세요"
        },
        "phoneObj": {
            "title": "휴대폰 번호",
            "tit": "휴대폰 로그인",
            "tip": "휴대폰 번호를 입력해 주세요",
            "formatTip": "올바른 휴대폰 번호 형식을 입력해 주세요"
        },
        "emailOrPhoneObj": {
            "title": "이메일 또는 휴대폰 번호",
            "tit": "이메일 또는 휴대폰 번호 로그인",
            "tip": "이메일 또는 휴대폰 번호를 입력해 주세요",
            "formatTip": "올바른 이메일 또는 휴대폰 번호 형식을 입력해 주세요"
        },
        "wechatObj": {
            "title": "위챗",
            "tit": "위챗 로그인"
        },
        "googleObj": {
            "title": "구글",
            "tit": "구글 로그인"
        },
        "confirm": "확인",
        "confirmSubmit": "제출 확인",
        "cancel": "취소",
        "close": "닫기",
        "bindSucMsg": "연결 성공",
        "toContinueBindAccount": "계속하여 제3자 계정 연결 완료",
        "bindTip01": "계정이 없으신가요? 하나 등록하세요",
        "bindTip02": "기존 계정이 있으신가요",
        "bindTip03": "현재 제3자 계정이 플랫폼 계정에 연결되지 않았습니다. 기존 계정을 연결하거나 새 계정을 등록하고 연결해 주세요. 다음부터 빠르게 로그인할 수 있습니다.",
        "bindTip04": "기존 계정 연결",
        "bindTip05": "새 계정 등록 및 연결",
        "bindTip06": "제3자 인증을 완료하셨습니다. 아래 로그인 정보를 완성하면 연결이 완료됩니다",
        "bindSubmit": "연결 제출",
        "enterAccountTip": "계정 이름을 입력해 주세요",
        "RegisterAndBind": "등록 및 연결",
        "loginErr": "사용자 이름 또는 비밀번호가 잘못되었습니다！",
        "usercenter": "사용자 센터",
        "pleaseInputName": "이름을 입력해 주세요",
        "operationSuccess": "작업 성공！",
        "edit": "편집",
        "xiugai": "수정",
        "userData": "개인 정보",
        "changePassword": "비밀번호 수정",
        "account": "계정",
        "userName01": "사용자 이름",
        "phoneNumber": "휴대폰 번호",
        "role": "역할",
        "createTime": "생성 시간",
        "genghuang": "교체",
        "bangding": "연결",
        "unbind": "연결 해제",
        "plesaseSelectBindingType": "연결 유형을 선택해 주세요",
        "pleaseConfirmCont": "이 내용을 읽었음을 확인해 주세요",
        "confirmReadCont": "이 내용을 읽었습니다",
        "frequentTip": "작업이 너무 빈번합니다. 잠시 후 다시 시도해 주세요!",
        "zhuxiaoBtn": "계정 탈퇴",
        "zhuxiaoTitle": "계정 탈퇴",
        "querenZhuxiao": "탈퇴 확인",
        "jiXu": "계속",
        "sendCodeBtn": "인증 코드 전송",
        "passwordIsNotOldPassword": "확인 비밀번호와 새 비밀번호가 일치하지 않습니다",
        "passwordIsOldPassword": "수정한 비밀번호가 원본 비밀번호와 같습니다",
        "passFormatError": "올바른 비밀번호 형식을 입력해 주세요",
        "oldPassWord": "기존 비밀번호",
        "newPassWord": "새 비밀번호",
        "inputPlaceholder": "입력해 주세요",
        "confirmPassword": "비밀번호 확인",
        "zhuxiaoTip": "\n            1、계정 탈퇴는 복구 불가능한 작업으로, 탈퇴 후 해당 계정이나 해당 계정으로 등록·로그인한 제3자 계정을 다시 로그인하고 사용할 수 없습니다. 계정 관련 정보 및 데이터는 직접 백업해 주세요.\n            2、본 계정을 등록하기 전, 모든 자산 등을 비우고 분쟁이 없음을 반드시 확인해 주세요; 본 계정이 탈퇴되면 계정 내 모든 자산 및 권리에 대한 소유권을 포기한 것으로 간주되며, 복구하거나 찾을 수 없습니다.\n            3、동일한 휴대폰 번호로 등록한 계정이 누적 3회 탈퇴한 경우, 해당 휴대폰 번호로 새 계정을 다시 등록할 수 없으며, 다른 어떤 계정에도 연결할 수 없습니다.\n            "
    },
    "home": {
        "title": "홈페이지",
        "quickOperation": "빠른 작업",
        "addDevice": "장치 추가",
        "publishProgram": "프로그램 발송",
        "publishMaterial": "소재 발송",
        "makeProgram": "프로그램 제작",
        "uploadMaterial": "소재 업로드",
        "todayData": "오늘 데이터 (매시간 업데이트)",
        "playNumChart": "재생 횟수 통계",
        "deviceOnlineStatus": "장치 온라인 상태",
        "onLineDevice": "온라인 장치",
        "unLineDevice": "오프라인 장치",
        "programPlayTime": "프로그램 재생 시간 통계",
        "downloadSoft": "소프트웨어 다운로드",
        "adminApp": "모바일 사용자 단말",
        "playerApp": "정보 발송 재생 단말",
        "downloadAdminApp": "클릭하여 사용자 단말 다운로드",
        "downloadPlayerApp": "클릭하여 재생 단말 다운로드",
        "aboutUs": "회사 소개",
        "userManual": "사용자 매뉴얼",
        "message": "메시지 남기기"
    },
    "device": {
        "inputPlaceholder": "입력해 주세요",
        "selectPlaceholder": "선택해 주세요",
        "osTypeStr": "단말 시스템",
        "onLineStatus": "온라인 상태",
        "dpi": "해상도",
        "companyDeptIdName": "소속 기관",
        "deviceGroupIdName": "소속 그룹",
        "editOrMove": "편집/이동",
        "loanOriginationFee": "대출 수수료",
        "strategyInfoLook": "전략 정보 보기",
        "programLook": "프로그램 보기",
        "addEquipments": "장치 추가",
        "luminanceSet": "밝기 제어",
        "terminal": "단말 설정",
        "transferCompany": "부서 이전",
        "releasedProgram": "프로그램 발송",
        "screenshot": "스크린샷",
        "changeGroup": "그룹 변경",
        "defaultGroup": "기본 그룹",
        "operation": "작업",
        "edit": "편집",
        "saveEdit": "편집 저장",
        "add": "추가",
        "save": "저장",
        "setting": "설정",
        "program": "프로그램",
        "unbind": "연결 해제",
        "sleep": "휴면",
        "wakeup": "각성",
        "restart": "재시작",
        "shutdown": "전원 끄기",
        "reportLog": "로그 보고",
        "clearPlayData": "재생 단말 데이터 삭제",
        "offlineWarn": "이 장치는 오프라인 상태입니다. 장치가 온라인이 된 후 다시 시도해 주세요！",
        "confirmUnbind": "연결 해제 확인",
        "confirmReset": "삭제 확인",
        "confirmDelete": "삭제 확인",
        "delete": "삭제",
        "cancelDelete": "삭제 취소",
        "confirmResetSuccess": "삭제 성공",
        "confirm": "확인",
        "cancel": "취소",
        "operationSuccess": "작업 성공",
        "unbindSuccess": "연결 해제 성공",
        "pleaseSelectDevice": "장치를 선택해 주세요",
        "pleaseSelectOnlineDevice": "온라인 장치를 선택해 주세요",
        "confirmMixOperation": "선택한 장치에 오프라인 장치가 포함되어 있으며, 해당 설정은 오프라인 장치에 적용되지 않습니다. 계속 작업할지 확인하시겠습니까？",
        "pleaseSelectDate": "날짜를 선택해 주세요",
        "reportSuccess": "보고 성공",
        "deviceSetting": "장치 설정",
        "default": "기본값",
        "all": "전체",
        "deviceList": "장치 목록",
        "addDevice": "장치 추가",
        "department": "부서 기관",
        "deviceType": "해상도",
        "osType": "단말 시스템",
        "onlineState": "온라인 상태",
        "online": "온라인",
        "offline": "오프라인",
        "notActive": "활성화되지 않음",
        "search": "키워드를 입력해 주세요",
        "batchOperation": "일괄 작업",
        "allDevices": "전체 장치",
        "deviceAttribute": "장치 속성",
        "selectReportDate": "보고 날짜 선택",
        "inputName": "이름을 입력해 주세요",
        "inputWidth": "너비를 입력해 주세요",
        "inputHeight": "높이를 입력해 주세요",
        "inputResolutionRatio": "0보다 큰 정수를 입력해 주세요！",
        "inputSort": "정렬을 입력해 주세요",
        "serialNum": "일련 번호",
        "name": "이름",
        "width": "너비",
        "height": "높이",
        "resolutionRatio": "해상도",
        "inputResolutionRatioName": "해상도 이름을 입력해 주세요",
        "sort": "정렬",
        "personal": "개인",
        "system": "시스템",
        "type": "유형",
        "systemDefaultSettingUneditable": "시스템 기본 설정은 편집할 수 없습니다!",
        "systemDefaultSettingUnDeletable": "시스템 기본 설정은 삭제할 수 없습니다!",
        "newz": "새로 추가",
        "total": "총",
        "totalNum": "건",
        "strategyName": "전략 이름",
        "associatedTerminalNum": "관련 단말 수",
        "createTime": "생성 시간",
        "pleaseSelectStrategy": "전략을 선택해 주세요！",
        "onlySelectOneData": "데이터는 한 건만 선택할 수 있습니다！",
        "downloadStrategy": "전략 다운로드",
        "inputStrategyName": "전략 이름을 입력해 주세요",
        "luminanceControl": "밝기 제어",
        "volumeStrategy": "볼륨 전략",
        "saveSuccess": "저장 성공",
        "screenAngle": "화면 회전(°)",
        "startTime": "시작 시간",
        "endTime": "종료 시간",
        "repeat": "반복",
        "monday": "월요일",
        "tuesday": "화요일",
        "wednesday": "수요일",
        "thursday": "목요일",
        "friday": "금요일",
        "saturday": "토요일",
        "sunday": "일요일",
        "everyday": "매일",
        "downloadSpeed": "다운로드 속도",
        "inputDownloadSpeed": "다운로드 속도를 입력해 주세요",
        "operator": "작업",
        "pleaseSelectDeleteData": "삭제할 데이터를 선택해 주세요！",
        "confirmBatchDelete": "일괄 삭제를 확인하시겠습니까？",
        "pleaseInputName": "이름을 입력해 주세요",
        "detailSetting": "상세 설정",
        "weekPlan": "주간 계획",
        "specialDateSetting": "특수 날짜 설정",
        "weekdayInfo": "요일은 필수 선택 항목입니다!",
        "volumeInfo": "볼륨은 필수 선택 항목입니다!",
        "timeError": "시간 선택 오류!",
        "editSuccess": "편집 작업 성공！",
        "addSuccess": "추가 작업 성공！",
        "addSpecialPlan": "특수 전략 계획 추가",
        "downloadSpeedInfo": "다운로드 속도:(0은 다운로드 금지를 의미)",
        "pleaseSelectStartTime": "시작 시간을 선택해 주세요",
        "pleaseSelectEndTime": "종료 시간을 선택해 주세요",
        "luminanceError": "올바른 밝기 값을 입력해 주세요！",
        "defaultLuminance": "기본 밝기",
        "luminance": "밝기 크기",
        "defaultLuminanceInfo": "기본 밝기(100은 가장 밝음, 0은 가장 어두움)",
        "volume": "볼륨",
        "saveLuminance": "밝기 저장",
        "changeSuccess": "변경 성공！",
        "changeNetwork": "네트워크 교체",
        "netName": "네트워크 이름",
        "nameempty": "네트워크 이름은 필수입니다",
        "currentNetwork": "현재 네트워크",
        "ipAddress": "IP 주소",
        "dailyMode": "매일 모드",
        "weeklyMode": "주간 모드",
        "turnOnTime": "전원 켜기 시간",
        "turnOffTime": "전원 끄기 시간",
        "startSleep": "휴면 시작",
        "endSleep": "휴면 종료",
        "batchDelInfo": "선택한 항목을 삭제하시겠습니까？",
        "timeCannotBeEmpty": "시간은 비어 있을 수 없습니다!",
        "startUp": "전원 켜기",
        "shutDown": "전원 끄기",
        "volumeSize": "볼륨 크기",
        "defaultVolume": "기본 볼륨(100은 최대, 0은 무음)",
        "chooseStartTime": "시작 시간을 선택해 주세요",
        "chooseEndTime": "종료 시간을 선택해 주세요",
        "saveVolume": "볼륨 저장",
        "screenRotationUnSaved": "화면 회전이 저장되지 않았습니다",
        "volumeSettingUnSaved": "볼륨 설정이 저장되지 않았습니다",
        "luminanceSettingUnSaved": "밝기 설정이 저장되지 않았습니다",
        "confirmClosePopup": "이 팝업을 닫으시겠습니까?",
        "volumeSettingSuccess": "볼륨 수정 성공",
        "luminanceSettingSuccess": "밝기 수정 성공",
        "advancedSettingUnSaved": "고급 설정이 저장되지 않았습니다",
        "settingTitle": "단말 설정",
        "volumeSetting": "볼륨 설정",
        "luminanceSetting": "밝기 설정",
        "downloadSetting": "다운로드 설정",
        "sleepSetting": "휴면 설정",
        "onOffSetting": "정기 전원 온/오프",
        "screenRotation": "화면 회전",
        "namingError": "명명 오류, 파일 이름에 공백을 포함할 수 없습니다！",
        "deleteSuccess": "삭제 성공",
        "deleteFolder": "폴더 삭제",
        "pleaseInputDeviceName": "장치 이름을 입력해 주세요",
        "pleaseInputDeviceId": "장치 ID를 입력해 주세요",
        "discoverDevice": "장치 발견",
        "deviceId": "장치 ID",
        "bound": "연결 완료",
        "bind": "연결",
        "noDevice": "장치가 없습니다",
        "refresh": "새로 고침",
        "manualAdd": "수동 추가",
        "deviceGroup": "장치 분류",
        "pleaseSelectGroup": "그룹을 선택해 주세요！",
        "deviceName": "장치 이름",
        "goAdd": "추가로 이동",
        "close": "닫기",
        "bindCountInsufficient": "연결 가능한 수량이 부족합니다. 장치 수를 업그레이드한 후 추가해 주세요！",
        "displayNumber": "표시 번호",
        "groupName": "그룹 이름",
        "pleaseSelectGroupName": "그룹 이름을 작성해 주세요！",
        "moveGroup": "그룹 이동",
        "longitude": "경도",
        "latitude": "위도",
        "nationality": "국적",
        "province": "성",
        "city": "시",
        "county": "현",
        "outNetIp": "외부 네트워크 IP",
        "inNetIp": "내부 네트워크 IP",
        "companyName": "기업 이름",
        "Info": "상세 정보",
        "android": "안드로이드",
        "win": "윈도우",
        "osVersion": "시스템 버전",
        "softwareVersion": "소프트웨어 버전",
        "diskSize": "디스크 크기",
        "useSize": "사용된 크기",
        "macAddr": "MAC 주소",
        "longitudeLatitudeInfo": "경위도는 동시에 비어 있거나 비어 있지 않아야 합니다!",
        "terminalName": "단말 이름",
        "terminalGroup": "단말 그룹",
        "reportJournal": "보고 여부",
        "systemVersion": "시스템 버전",
        "storageSpace": "저장 공간",
        "resolution": "해상도",
        "runningMemory": "실행 메모리",
        "model": "모델",
        "registerStatus": "등록 상태",
        "password": "비밀번호",
        "passwordInfo": "6~18자의 단어 또는 숫자를 입력해 주세요!",
        "group": "그룹",
        "address": "주소",
        "remark": "비고",
        "renewalPeriod": "갱신 주기",
        "money": "비용",
        "latitudeInfo": "올바른 위도를 입력해 주세요!",
        "totalPayment": "총 금액",
        "longitudeInfo": "올바른 경도를 입력해 주세요!",
        "setMeal": "패키지",
        "number": "수량",
        "programName": "프로그램 이름",
        "playStatus": "재생 상태",
        "playType": "재생 방식",
        "play": "재생",
        "pause": "일시 정지",
        "playTime": "재생 시간",
        "programDeleted": "프로그램이 삭제되었습니다",
        "playSuccess": "프로그램 재생이 예정되었습니다",
        "pauseSuccess": "일시 정지 성공",
        "playCycle": "순환 재생",
        "playInsert": "삽입 재생",
        "withdrawSuccess": "회수 성공",
        "withdrawInfo": "먼저 회수할 프로그램을 선택해 주세요！",
        "programBelong": "소속 프로그램",
        "checkAll": "전체 선택",
        "batchDel": "일괄 삭제",
        "delConfirm": "선택한 항목을 삭제하시겠습니까？",
        "check": "선택됨",
        "noProgram": "프로그램이 없습니다",
        "details": "상세 정보",
        "screenshotFail": "스크린샷 실패",
        "policyName": "정책 이름",
        "terminalNum": "관련 단말 수",
        "powerStrategy": "전원 전략",
        "pleaseSelectDepartment": "부서를 선택해 주세요！",
        "screenshotControl": "스크린샷 제어",
        "未激活": "활성화되지 않음",
        "已激活": "활성화됨",
        "未绑定": "연결되지 않음",
        "已绑定": "연결 완료"
    },
    "programManage": {
        "programList": "프로그램 목록",
        "publishProgram": "프로그램 발송 추적",
        "week1": "월요일",
        "week2": "화요일",
        "week3": "수요일",
        "week4": "목요일",
        "week5": "금요일",
        "week6": "토요일",
        "week7": "일요일",
        "monday": "월요일",
        "tuesday": "화요일",
        "wednesday": "수요일",
        "thursday": "목요일",
        "friday": "금요일",
        "saturday": "토요일",
        "sunday": "일요일",
        "name": "이름",
        "preview": "미리보기",
        "playDeviceNum": "재생 장치 수",
        "copyDeviceCode": "클릭하여 복사",
        "osType": "시스템 유형",
        "playDate": "재생 날짜",
        "playWeek": "재생 주",
        "everyday": "매일",
        "start": "시작",
        "end": "종료",
        "playOperateStatusStr": "발송 상태",
        "playDevice": "재생 장치",
        "downloadView": "다운로드 보기",
        "publisher": "발송자",
        "publishTime": "발송 시간",
        "operation": "작업",
        "add": "추가",
        "groupName": "그룹 이름",
        "selectDevice": "단말 선택",
        "searchDevice": "단말 검색",
        "pleaseFillGroupName": "그룹 이름을 작성해 주세요！",
        "remarkInfo": "비고",
        "compile": "편집",
        "withdrawConfirm": "이 프로그램을 회수할지 확인하시겠습니까？",
        "confirm": "확인",
        "cancel": "취소",
        "withdraw": "회수",
        "batchWithdraw": "일괄 회수",
        "batchPublish": "일괄 발송",
        "batchDelete": "일괄 삭제",
        "batchOperation": "일괄 작업",
        "notUse": "사용되지 않음",
        "notChecked": "심사되지 않음",
        "notPass": "통과되지 않음",
        "delete": "삭제",
        "publishTextLeft": "발송 완료",
        "offTextLeft": "일시 정지됨",
        "pleaseSelectProgramToMove": "이동할 프로그램을 선택해 주세요！",
        "pause": "일시 정지",
        "pauseConfirm": "일시 정지할지 확인하시겠습니까？",
        "play": "재생",
        "downloadUdisk": "USB 플래시 드라이브 다운로드",
        "deviceList": "장치 목록",
        "groupSelection": "그룹 선택",
        "operationSuccess": "작업 성공",
        "deleteSuccess": "삭제 성공",
        "selectDate": "날짜 선택",
        "publishStatus": "발송 상태",
        "checkStatus": "심사 상태",
        "waitAuditing": "심사 대기",
        "auditPass": "심사 통과",
        "auditRefuse": "심사 거부",
        "all": "전체",
        "playStatus": "재생 중",
        "playStatust": "재생 상태",
        "pauseStatus": "일시 정지됨",
        "notStartStatus": "시작되지 않음",
        "resolutionratio": "해상도",
        "totalNum": "건",
        "programName": "프로그램 이름",
        "playStartTime": "재생 시작 시간",
        "playEndTime": "재생 종료 시간",
        "createTime": "생성 시간",
        "nationality": "국적",
        "province": "성",
        "city": "시",
        "county": "현·구",
        "address": "주소",
        "ip": "IP 주소",
        "location": "위치",
        "log": "로그",
        "pleaseFillProgramName": "프로그램 이름을 작성해 주세요！",
        "selectGroup": "그룹 선택",
        "startTime": "시작 시간",
        "endTime": "종료 시간",
        "publishCycle": "발송 주기",
        "publishDeviceNum": "발송 장치 수",
        "pleaseSelectRecord": "기록을 선택해 주세요",
        "deviceName": "단말 이름",
        "deviceId": "단말 장치 ID",
        "deviceGroupIdName": "소속 그룹",
        "notClassified": "분류되지 않음",
        "osTypeStr": "단말 시스템",
        "storageSpace": "저장 공간",
        "onLineStatus": "온라인 상태",
        "onLine": "온라인",
        "offLine": "오프라인",
        "sleep": "휴면",
        "unknown": "알 수 없음",
        "registerStatus": "등록 상태",
        "trialPeriod": "평가 기간",
        "notActive": "활성화되지 않음",
        "active": "활성화됨",
        "parameterError": "매개변수가 잘못되었습니다!",
        "pleaseSelectProgram": "프로그램을 선택해 주세요!",
        "pleaseSelectProgramEdit": "편집할 프로그램을 선택해 주세요!",
        "confirmWithdrawSelectedProgram": "선택한 프로그램을 회수할지 확인하시겠습니까？",
        "withdrawSuccess": "회수 성공",
        "allPrograms": "전체 프로그램",
        "defaultGroup": "기본 그룹",
        "cannotShareEmptyProgram": "빈 프로그램은 공유할 수 없습니다！",
        "onlyShareYourProgram": "자신이 생성한 프로그램만 공유할 수 있습니다!",
        "pleaseSelectProgramEditPublishTime": "발송 시간을 편집한 프로그램을 선택해 주세요!",
        "pleaseSelectDevice": "장치를 선택해 주세요!",
        "programDetail": "프로그램 상세 정보",
        "errorReason": "오류 원인",
        "availableStorageSpaceInsufficient": "사용 가능한 저장 공간이 부족합니다",
        "partialDeviceReleaseFailure": "일부 장치 발송 실패",
        "allDeviceReleaseSuccess": "모든 장치 발송 성공",
        "partialDeviceReleaseSuccess": "일부 장치 발송 성공",
        "allGroup": "모든 그룹",
        "allProgram": "모든 프로그램",
        "unGrouped": "그룹화되지 않음",
        "replaceProgram": "프로그램 교체",
        "replaceProgramTip": "새로 발송된 프로그램은 재생 단말에 기존에 전송된 프로그램 데이터를 교체합니다！",
        "screen": "단일/이중 화면",
        "singleScreen": "단일 화면",
        "doubleScreen": "이중 화면",
        "playSetting": "재생 설정",
        "batchPlaySetting": "재생 시간 일괄 설정",
        "individualPlaySetting": "재생 시간 개별 설정",
        "playTime": "재생 시간",
        "daily": "매일",
        "weekdays": "월요일부터 금요일까지",
        "monthly": "당월",
        "advancedSetting": "고급 설정",
        "playProgram": "프로그램 재생",
        "searchProgram": "키워드를 입력해 주세요",
        "shareAddressNotExist": "링크 주소가 존재하지 않습니다. 다시 시도해 주세요",
        "copySuccess": "복사 성공",
        "shareLink": "공유 링크",
        "publish": "발송",
        "noResource": "자원이 없습니다",
        "single": "단일 화면",
        "double": "이중 화면",
        "time": "시간",
        "associatedTerminalNum": "관련 단말 수",
        "default": "기본값",
        "moveGroup": "그룹 이동",
        "pleaseSelectGroup": "그룹 이름을 작성해 주세요！",
        "copy": "복사",
        "FUBEN": "복사본",
        "nameempty": "이름은 필수입니다",
        "whitespace": "명명 오류, 파일 이름에 공백을 포함할 수 없습니다！",
        "programWhitespace": "명명 오류, 프로그램 이름에 공백을 포함할 수 없습니다！",
        "pleaseSelectResolution": "해상도를 선택해 주세요！",
        "dataError": "데이터가 잘못되었습니다！",
        "createProgram": "새 프로그램 생성",
        "directCreate": "직접 생성",
        "myTemplate": "내 템플릿",
        "use": "사용",
        "free": "무료",
        "loadMore": "더 불러오기",
        "confirmDelete": "삭제 확인",
        "deleteGroup": "그룹 삭제",
        "notPublished": "발송되지 않음",
        "notPassed": "통과되지 않음",
        "notUsed": "사용되지 않음",
        "confirmDeleteSelectedProgram": "선택한 프로그램을 삭제할지 확인하시겠습니까？",
        "companyName": "기업 이름",
        "programCannotDownload": "이 프로그램은 다운로드할 수 없습니다！",
        "publishMaterial": "소재 발송",
        "playMaterial": "소재 재생",
        "pleaseInputMaterialName": "소재 이름을 입력해 주세요",
        "size": "크기",
        "pleaseInputDeviceName": "장치 이름을 입력해 주세요",
        "item": "건",
        "allMaterial": "전체 소재",
        "allDevices": "전체 장치",
        "saveSuccess": "저장 성공",
        "savefaill": "저장 실패",
        "playMode": "재생 모드",
        "cyclePlay": "순환 재생",
        "insertPlay": "삽입 재생",
        "noData": "데이터가 없음",
        "Add": "새로 추가",
        "replace": "교체",
        "repeat": "반복",
        "start01": "시작",
        "end01": "종료",
        "startDate": "시작 날짜",
        "endDate": "종료 날짜",
        "useNow": "즉시 사용",
        "fillStartEndTimeFirst": "추가하기 전에 시작 시간과 종료 시간을 작성해주세요",
        "fillFullPlayTime": "완전한 재생 시간을 작성해주세요",
        "fillCorrectPlayTime": "정확한 재생 시간대를 작성해주세요",
        "sDateAndEDateBothEmptyOrFilled": "시작 날짜와 종료 날짜는 모두 비우거나 모두 작성해야 합니다"
    },
    "source": {
        "addResource": "자원 추가",
        "width": "너비",
        "height": "높이",
        "size": "크기(KB)",
        "name": "이름",
        "pleaseInputResourceName": "자원 이름을 입력해 주세요！",
        "addToGroup": "그룹에 추가",
        "remark": "비고",
        "promptFgIllustrate": "삽화",
        "promptFgRealisticPhoto": "사실적인 사진",
        "promptFgSimplisticDrawing": "간단한 그림",
        "promptFgChineseStyle": "중국풍",
        "promptFgPixelArt": "픽셀 아트",
        "noModel": "모델이 없습니다. 관리자에게 문의하세요！",
        "getModelFailed": "모델을 가져오는 데 실패했습니다. 잠시 후 다시 시도하세요! 또는 관리자에게 문의하세요！",
        "createImagePrompt": "이미지를 생성 중입니다. 잠시 후 닫아주세요！",
        "promptEmpty": "프롬프트를 입력해 주세요",
        "dpiEmpty": "이미지 비율을 선택해 주세요！",
        "fgEmpty": "스타일을 선택해 주세요！",
        "style": "스타일",
        "idEmpty": "이미지 ID는 필수입니다",
        "exist": "해당 이미지는 이미 소재에 존재합니다",
        "addSuccess": "소재 추가 성공",
        "saveError": "이미지 저장에 실패했습니다. 잠시 후 다시 시도하세요！",
        "delSuccess": "삭제 성공",
        "generateImage": "텍스트로 이미지 생성",
        "generateImagePlaceholder": "생성하고 싶은 이미지를 입력해 주세요. 예: 나비 한 마리가 꽃밭에서 춤추고 있음",
        "aiExpand": "지능형 확장",
        "negativePrompt": "네거티브 프롬프트",
        "negativePromptTooltip": "사용자가 출력 결과에 나타나기를 원하지 않는 내용이나 특징을 명확히 제외하는 데 사용됩니다",
        "imageRatio": "이미지 비율",
        "generateImageBtn": "즉시 생성",
        "shengchengjieguo": "생성 결과",
        "generateImageLoadingTip": "생성 중입니다. 반복 클릭하거나 닫지 마세요...",
        "Tooltip": "AI로 당신의 아이디어를 구현해 보세요",
        "saveToMaterial": "소재에 저장",
        "publish": "즉시 발송",
        "download": "다운로드",
        "generateHistory": "생성 기록",
        "hide": "접기",
        "cancel": "취소",
        "useExpand": "확장 사용",
        "all": "전체",
        "delete": "삭제",
        "loadMore": "더 불러오기",
        "aiTip": "콘텐츠는 인공지능 모델이 생성한 것으로, 플랫폼의 견해·입장·태도를 대변하지 않습니다. AI 콘텐츠를 합리적이고 규범적으로 사용해 주세요",
        "operationSuccess": "작업 성공",
        "moveGroup": "그룹 이동",
        "groupName": "그룹 이름",
        "pleaseSelectGroup": "그룹 이름을 선택해 주세요！",
        "shenhe": "심사",
        "shenheStatus": "심사 상태",
        "shenheSuccess": "심사 통과",
        "shenheRefuse": "심사 거부",
        "pleaseSelectShenheStatus": "심사 상태를 선택해 주세요！",
        "shenheRemark": "심사 비고",
        "pleaseInputShenheRemark": "심사 비고를 입력해 주세요！",
        "pleaseInputFileName": "파일 이름을 입력해 주세요！",
        "whitespace": "명명 오류. 파일 이름에 공백을 포함할 수 없습니다！",
        "dataError": "데이터가 잘못되었습니다！",
        "confirmDelete": "삭제 확인",
        "confirm": "확인",
        "deleteFolder": "폴더 삭제",
        "add": "추가",
        "edit": "편집",
        "fileName": "파일 이름",
        "group": "그룹",
        "resolution": "해상도",
        "type": "유형",
        "image": "이미지",
        "music": "음악",
        "video": "동영상",
        "uploadTime": "업로드 시간",
        "uploadUser": "업로드자",
        "checkTime": "심사 시간",
        "checkUser": "심사자"
    },
    "setting": {
        "nameempty": "이름은 필수입니다",
        "heightempty": "높이는 필수입니다",
        "widthempty": "너비는 필수입니다",
        "resolutionratio": "해상도",
        "name": "이름",
        "opteration": "작업",
        "compile": "편집",
        "delete": "삭제",
        "newz": "새로 추가",
        "compileratio": "해상도 편집",
        "sheizhifenbianlvmingcheng": "해상도 이름 설정",
        "shezhigaodu": "높이 설정",
        "shezhikuandu": "너비 설정",
        "xinzengfenbianlv": "해상도 새로 추가",
        "bianma": "코딩",
        "bianjizhongduanmingcheng": "단말 이름 편집",
        "xinzengzhongduan": "단말 새로 추가",
        "selectPrimaryColor": "테마 색상 선택",
        "fullScreen": "전체 화면",
        "exitFullScreen": "전체 화면 종료"
    },
    "tabs": {
        "refresh": "새로 고침",
        "refreshAll": "전체 새로 고침",
        "close": "닫기",
        "closeOthers": "다른 탭 닫기",
        "closeAll": "모든 탭 닫기",
        "closeLeft": "왼쪽 탭 닫기",
        "closeRight": "오른쪽 탭 닫기"
    },
    "errorPage": {
        "needLogin": "아직 로그인하지 않으셨습니다！",
        "pageNotFound": "접근하신 페이지가 존재하지 않습니다！",
        "redirectTo": "다음 페이지로 이동합니다",
        "orReturn": "또는 돌아가기",
        "previousStep": "이전 단계"
    },
    "headerUs": {
        "systemNotice": "시스템 알림",
        "allNotices": "전체 알림",
        "viewAllMessages": "전체 메시지 보기",
        "contactUs": "문의하기",
        "operationSuccess": "작업 성공！",
        "leaveMessage": "메시지 남기기",
        "messageTitle": "제목",
        "messageTitleTip": "제목을 입력해 주세요！",
        "messageContentTip": "150자 이내",
        "submit": "제출",
        "markAsRead": "읽음으로 표시",
        "success": "작업 성공！"
    },
    "material": {
        "allMaterial": "전체 소재",
        "defaultGroup": "기본 그룹",
        "auditStatus": "심사 상태",
        "auditPassed": "심사 통과",
        "auditRejected": "심사 거부",
        "pendingAudit": "심사 대기",
        "all": "전체",
        "operateSuccess": "작업 성공！",
        "pleaseSelectMaterial": "소재를 선택해 주세요！",
        "moveGroup": "그룹 이동",
        "pleaseSelectGroup": "그룹을 선택해 주세요！",
        "batchPublish": "일괄 발송",
        "batchRecall": "일괄 회수",
        "batchDelete": "일괄 삭제",
        "materialList": "소재 목록",
        "uploadMaterial": "소재 업로드",
        "materialType": "소재 유형",
        "pleaseInputMaterialName": "소재 이름을 입력해 주세요",
        "selectAll": "전체 선택",
        "confirmDeleteSelectedMaterial": "선택한 소재를 삭제하시겠습니까？",
        "deleteSuccess": "삭제 성공",
        "delete": "삭제",
        "publish": "발송",
        "recall": "회수",
        "confirmRecallSelectedMaterial": "선택한 소재를 회수하시겠습니까？",
        "pleaseSelectMaterialGroup": "소재 그룹을 선택해 주세요！",
        "recallSuccess": "회수 성공",
        "publishSuccess": "발송 성공",
        "batchOperate": "일괄 작업",
        "item": "건",
        "confirmDelete": "삭제하시겠습니까？",
        "edit": "편집",
        "confirmRecall": "회수하시겠습니까？",
        "unaudited": "심사되지 않음",
        "notPassed": "통과되지 않음",
        "operate": "작업",
        "resolution": "해상도",
        "none": "없음",
        "confirm": "확인",
        "cancel": "취소",
        "AICreation": "AI 창작"
    },
    "uploadFile": {
        "operationSuccess": "작업 성공",
        "uploadFile": "업로드 관리",
        "uploadSuccess": "업로드 성공",
        "uploadCompleted": "업로드 완료",
        "uploadFail": "업로드 실패",
        "ConversionFailed": "변환 실패！",
        "loading": "열심히 로딩 중...",
        "beQueuing": "대기 중...",
        "Uploading": "업로드 중...",
        "ConversionIng": "변환 중...",
        "ConventionalResources": "일반 자원",
        "DocumentResources": "문서 자원",
        "complete": "완료",
        "upload": "업로드",
        "fileSizeWraning01": "소재 크기가 초과했습니다",
        "fileSizeWraning02": "수정 후 다시 업로드해 주세요！",
        "fileIsEmpty": "파일이 비어 있습니다",
        "uploadFileTip": "지원하지 않는 파일 형식입니다",
        "unablePreview": "소재 라이브러리에 성공적으로 추가되지 않아 미리볼 수 없습니다",
        "confirmDelete": "삭제하시겠습니까？",
        "deleteSuccess": "삭제 성공",
        "delete": "삭제",
        "confirm": "확인",
        "preview": "미리보기",
        "close": "닫기",
        "cancel": "취소",
        "fileType": "파일 유형",
        "fileSize": "파일 크기",
        "conversionProgress": "변환 진행률",
        "progress": "진행률",
        "image": "이미지",
        "video": "동영상",
        "audio": "음악",
        "limitTip01": "한 번에 업로드",
        "limitTip02": "개 파일",
        "okTip": "소재를 업로드 중입니다. 잠시 후 닫아주세요！",
        "usableSize": "사용 가능한 용량",
        "sizeUnableTip": "현재 사용 가능한 저장 공간이 부족합니다. 불필요한 소재를 즉시 정리하여 공간을 절약하거나 딜러에게 문의하여 용량을 확장해 주세요.",
        "view": "상세 정보 보기",
        "fileName": "파일 이름"
    },
    "template": {
        "inputPlaceholder": "입력해 주세요",
        "selectPlaceholder": "선택해 주세요",
        "noAuths": "권한이 없습니다. 관리자에게 문의하세요",
        "operationSuccess": "작업 성공",
        "total": "총",
        "totalNum": "건",
        "dan": "단일",
        "shaung": "이중",
        "pleaseSelectGroup": "그룹을 선택해 주세요",
        "preview": "미리보기",
        "free": "무료",
        "use": "사용",
        "dpi": "해상도",
        "delete": "삭제",
        "confirmDelete": "삭제 확인",
        "confirmDeleteSelectedTemplate": "이 템플릿을 삭제하시겠습니까",
        "push": "발송",
        "pushConfirm": "공용 템플릿으로 발송하시겠습니까",
        "pushRemovalConfirm": "공용 템플릿에서 삭제하시겠습니까",
        "templateOrderRecord": "템플릿 주문 기록",
        "unpublished": "발송되지 않음",
        "auditing": "심사 중",
        "publishRejected": "발송 거부",
        "publishSuccess": "발송 성공",
        "offShelf": "하차",
        "公共模版": "공용 템플릿",
        "我的模板": "내 템플릿",
        "共享记录": "공유 기록",
        "name": "이름",
        "pubdate": "발송 시간",
        "keySeachTip": "키워드를 입력해 주세요",
        "allGroup": "전체 그룹",
        "add": "추가",
        "edit": "편집",
        "programName": "프로그램 이름",
        "selectGroup": "그룹 선택"
    },
    "checkManage": {
        "total": "총",
        "totalNum": "건",
        "operationSuccess": "작업 성공",
        "checkUserLogs": "심사 기록（운영자）",
        "checkLogs": "심사 기록（심사자）",
        "sourceCheck": "소재 심사",
        "programCheck": "프로그램 심사",
        "checkAll": "전체 선택",
        "auditPass": "심사 통과",
        "auditRefuse": "심사 거부",
        "auditPass01": "통과",
        "auditRefuse01": "거부",
        "auditRefuse02": "심사 거부",
        "auditor": "심사자",
        "agentUserName": "발송자",
        "interrogationTime": "심사 신청 시간",
        "checkTime": "심사 시간",
        "checkName": "심사 이름",
        "checkType": "심사 종류",
        "checkIp": "심사 신청 IP 주소",
        "checkReason": "메시지",
        "checkStatus": "작업 내용",
        "rangePicker": "심사 날짜",
        "keyWord": "키워드",
        "all": "전체",
        "program": "프로그램",
        "material": "소재",
        "dan": "단일",
        "shaung": "이중",
        "pleaseSelectProgram": "프로그램을 선택해 주세요!",
        "pleaseSelectMaterial": "소재를 선택해 주세요！",
        "preview": "미리보기",
        "dpi": "해상도",
        "auditRefuseTip": "거부 이유를 입력해 주세요",
        "unreviewed": "심사되지 않음",
        "notPassed": "통과되지 않음",
        "notUsed": "사용되지 않음",
        "edit": "편집",
        "none": "없음",
        "name": "이름",
        "size": "크기",
        "type": "유형",
        "uploadTime": "업로드 시간",
        "uploadUser": "업로드자",
        "checkUser": "심사자",
        "image": "이미지",
        "music": "음악",
        "video": "동영상"
    },
    "systemSet": {
        "total": "총",
        "totalNum": "건",
        "inputPlaceholder": "입력해 주세요",
        "selectPlaceholder": "선택해 주세요",
        "userList": "조직 구성원",
        "roleList": "역할 권한",
        "department": "조직 구조",
        "diskInfo": "저장 공간",
        "approveSet": "콘텐츠 심사",
        "logList": "로그 관리",
        "name": "성명",
        "account": "계정",
        "userName": "사용자 성명",
        "phoneNumber": "휴대폰 번호",
        "role": "역할",
        "createTime": "생성 시간",
        "operation": "작업",
        "edit": "편집",
        "delete": "삭제",
        "addNew": "새로 추가",
        "add": "추가",
        "resetPassword": "비밀번호 재설정",
        "confirmDelete": "삭제 확인",
        "departmentOrganization": "부서 기관",
        "addNewUser": "사용자 새로 추가",
        "pleaseEnterUserName": "사용자 성명을 입력해 주세요",
        "confirmPasswordNotMatch": "확인 비밀번호와 입력한 비밀번호가 다릅니다!",
        "operationSuccess": "작업 성공！",
        "userNickname": "사용자 이름",
        "pleaseEnterUserNickname": "사용자 이름을 입력해 주세요",
        "userNicknameRequired": "사용자 이름은 필수입니다！",
        "password": "비밀번호",
        "pleaseEnterPassword": "비밀번호를 입력해 주세요",
        "passwordRequired": "비밀번호는 필수입니다！",
        "passwordTip": "비밀번호의 보안 수준이 너무 낮습니다（비밀번호는 대소문자·숫자·특수 문자 중 임의 3종을 포함해야 하며 길이는 8자 이상）",
        "confirmPassword": "비밀번호 확인",
        "pleaseEnterPhoneNumber": "휴대폰 번호를 입력해 주세요",
        "phoneNumberRequired": "휴대폰 번호는 필수입니다！",
        "phoneNumberFormatError": "올바른 휴대폰 번호를 입력해 주세요！",
        "roleRequired": "역할은 필수입니다！",
        "required": "필수입니다！",
        "departmentName": "부서",
        "modifyPassword": "비밀번호 수정",
        "newPassword": "새 비밀번호",
        "pleaseEnterNewPassword": "새 비밀번호를 입력해 주세요",
        "pwdMessage": "비밀번호는 8~20자 이내이며, 공백을 포함할 수 없고 대소문자·숫자·특수 문자 중 임의 3종을 포함해야 합니다",
        "all": "전체",
        "noAuths": "권한이 없습니다. 관리자에게 문의하세요",
        "departmentName01": "부서 이름",
        "image": "이미지",
        "music": "음악",
        "video": "동영상",
        "buySize": "구매 수량",
        "totalMoney": "지불 금액",
        "buycreateTime": "구매 시간",
        "endTime": "만료 시간",
        "buyTypeStr": "주문 유형",
        "sourceCheck": "소재 심사",
        "programCheck": "프로그램 심사",
        "programName": "프로그램 이름",
        "diskExpansion": "사용 중에 만료되거나 사용하지 않는 소재를 적시에 정리하여 시스템의 사용 가능한 용량을 보장하는 것이 좋습니다. 더 큰 공간이 필요한 경우, 기기 공급업체에 연락하여 클라우드 저장 공간 용량 확장 서비스를 받으실 수 있습니다. 이 서비스는 비용이 발생할 수 있으며, 자세한 내용은 딜러의 정보를 참고하시기 바랍니다.",
        "selectPermission": "권한을 선택해 주세요",
        "checkPermission": "권한을 체크해 주세요",
        "addRole": "역할 추가",
        "enterRoleName": "역할 이름을 입력해 주세요",
        "roleName": "역할 이름",
        "roleNameRequired": "역할 이름은 필수입니다！",
        "remark": "비고",
        "enterRemark": "비고를 입력해 주세요",
        "permissionSetting": "권한 설정",
        "deleteSuccess": "삭제 성공！",
        "confirmToDelete": "삭제하시겠습니까？",
        "orgName": "기관 이름",
        "orgNameRequired": "기관 이름은 필수입니다！",
        "orgRemark": "기관 비고",
        "enterOrgRemark": "기관 비고를 입력해 주세요",
        "capacityUsage": "용량 사용 상태",
        "usedCapacity": "사용된 용량",
        "totalCapacity": "총 용량",
        "remainingCapacity": "남은 용량",
        "capacityExpansion": "용량 확장",
        "enable": "활성화",
        "disable": "비활성화",
        "userName01": "사용자 이름",
        "loginTime": "로그인 시간",
        "ipAddress": "IP 주소",
        "loginResult": "로그인 결과",
        "selectDate": "날짜 선택",
        "enterDate": "날짜를 선택해 주세요",
        "selectStartTime": "시작 시간을 선택해 주세요",
        "selectEndTime": "종료 시간을 선택해 주세요",
        "enterUserName": "사용자 이름을 입력해 주세요",
        "userCount": "사용자 수",
        "roleDesc": "역할 설명",
        "roleAuthorization": "역할 권한 부여",
        "success": "성공",
        "failure": "실패",
        "time": "시간",
        "operationContent": "작업 내용",
        "playCount": "재생 횟수",
        "playDuration": "재생 시간",
        "selectDevice": "장치 선택",
        "enterProgramName": "프로그램 이름을 입력해 주세요",
        "serialNumber": "일련 번호",
        "publishContentName": "발송 콘텐츠 이름",
        "playMode": "재생 방식",
        "cyclePlay": "순환 재생",
        "insertPlay": "삽입 재생",
        "paddingPlay": "보충 재생",
        "playDeviceId": "재생 장치 ID",
        "playDeviceName": "재생 장치 이름",
        "publishTime": "발송 시간",
        "downloadStatus": "다운로드 상태",
        "notDownloaded": "미다운로드",
        "downloading": "다운로드 중",
        "downloadSucceeded": "다운로드 성공",
        "downloadFailed": "다운로드 실패",
        "enterPublishContentName": "발송 콘텐츠 이름을 입력해 주세요",
        "terminalId": "단말 ID",
        "belongOrg": "소속 기관",
        "reportTime": "보고 시간",
        "reportIp": "보고 IP",
        "logInfo": "로그 정보",
        "details": "상세 정보",
        "confirmDeletion": "삭제하시겠습니까？",
        "logDetails": "로그 상세 정보",
        "download": "다운로드",
        "deptOrg": "부서 기관",
        "query": "조회",
        "queryByTerminalId": "단말 ID로 조회",
        "batchDeleteLogs": "로그 일괄 삭제",
        "customTimeDeleteLogs": "사용자 정의 시간으로 로그 삭제",
        "selectTimeRangeFirst": "먼저 시간 범위를 선택해 주세요",
        "deleteAllDeviceLogsIfEmpty": "장치 ID를 입력하지 않으면 기본적으로 모든 장치의 로그를 삭제합니다",
        "enterDeviceIdToDeleteLogs": "로그를 삭제할 장치 ID를 입력해 주세요",
        "confirmDeleteAction": "삭제 확인",
        "selectDeleteRangeFirst": "먼저 삭제 범위를 선택해 주세요",
        "networkConnectionFailed": "네트워크 연결 실패",
        "playLog": "재생 로그",
        "publishLog": "발송 로그",
        "errorLog": "오류 로그",
        "operationLog": "작업 로그",
        "fileLog": "파일 로그",
        "userOperateLog": "로그인 로그"
    },
    "userManual": {
        "userManual": "사용자 매뉴얼",
        "noData": "데이터가 없습니다"
    },
    "systemNotice": {
        "systemNotice": "시스템 알림",
        "noData": "데이터가 없습니다",
        "total": "총",
        "totalNum": "건",
        "markAllRead": "전체 읽음으로 표시",
        "deleteAll": "전체 삭제",
        "all": "전체",
        "unread": "읽지 않음",
        "read": "읽음",
        "type": "유형",
        "content": "내용",
        "date": "날짜",
        "status": "상태",
        "confirmDelete": "삭제하시겠습니까？",
        "confirm": "확인",
        "cancel": "취소",
        "delete": "삭제"
    }
};